/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StartTimeMove = {
    properties: {
        previousStart: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        actualStart: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
    },
} as const;
